import request from '@/utils/request'

/**
 * 获取电表列表
 * @param {Object} params
 * @param {Number|String} params.stationId 电站ID
 * @returns
 */
export function getMeterList({ stationId }) {
  return request({
    url: '/dashboard/meter/queryMeters',
    method: 'get',
    params: {
      stationId
    }
  })
}

/**
 * 获取电表数据列表
 * @param {Object} params
 * @param {String} params.startTime 开始时间
 * @param {String} params.endTime 结束时间
 * @param {Number|String} params.stationId 电站ID
 * @param {String} params.uuids 电表UUID列表，逗号分隔
 * @param {Number} params.pageNum 页码
 * @param {Number} params.pageSize 每页显示数
 * @param {String} [params.interval] 时间间隔：15m / 1h / 不传（原始粒度）
 * @param {Boolean} [params.diff] 差值模式：true 返回增量，false 返回累计读数
 * @returns
 */
export function getMeterDataList({ startTime, endTime, stationId, uuids, pageNum = 1, pageSize = 40, interval, diff }) {
  const params = {
    startTime,
    endTime,
    stationId: Number(stationId),
    uuids,
    pageNum,
    pageSize
  }
  // interval 和 diff 只在有值时传递，避免传 undefined
  if (interval) params.interval = interval
  if (diff != null) params.diff = diff

  return request({
    url: '/dashboard/meter/original/data/query',
    method: 'get',
    params
  })
}

/**
 * 导出电表数据
 * @param {Object} params
 * @param {String} params.startTime 开始时间
 * @param {String} params.endTime 结束时间
 * @param {Number|String} params.stationId 电站ID
 * @param {String} params.uuids 电表UUID列表，逗号分隔
 * @param {String} [params.interval] 时间间隔：15m / 1h / 不传（原始粒度）
 * @param {Boolean} [params.diff] 差值模式：true 返回增量，false 返回累计读数
 * @returns
 */
export function exportMeterDataRecord(params) {
  const reqParams = {
    stationId: Number(params.stationId),
    uuids: params.uuids,
    startTime: params.startTime,
    endTime: params.endTime
  }
  if (params.interval) reqParams.interval = params.interval
  if (params.diff != null) reqParams.diff = params.diff

  return request({
    url: '/dashboard/meter/original/data/export',
    method: 'get',
    params: reqParams,
    responseType: 'blob'
  }).then(blob => {
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19)
    link.setAttribute('download', `电表数据_${timestamp}.xlsx`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  })
}

/**
 * 导出电表数据日报表（一天的数据）
 * @param {Object} params
 * @param {String} params.startTime 开始时间
 * @param {String} params.endTime 结束时间
 * @param {Number|String} params.stationId 电站ID
 * @param {String} params.uuids 电表UUID列表，逗号分隔
 * @returns
 */
export function exportOneDayMeterDataRecord(params) {
  return request({
    url: '/dashboard/meter/day/energy/export',
    method: 'get',
    params: {
      stationId: Number(params.stationId),
      uuids: params.uuids,
      startTime: params.startTime,
      endTime: params.endTime
    },
    responseType: 'blob'
  }).then(blob => {
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url
    const fileName = `电表数据日报表_${params.startTime}_${params.endTime}.xlsx`
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  })
}





